module.exports = __webpack_public_path__ + "img/嘆きの海.5f2918b6.png";